module.exports = __webpack_public_path__ + "img/itemBar_01.bd6c25c8.png";